export default __webpack_public_path__ + "static/media/footerDos.ae9e6774.jpeg";